module.exports = __webpack_public_path__ + "static/limonade-2f8d800e2a80fdf3509976a67b169c2a.jpg";